var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ZyroTabs',{staticClass:"drawer__tabs",attrs:{"tabs":_vm.availableTabs,"current-tab":_vm.currentTab},on:{"change":function($event){return _vm.changeCurrentTab({
			drawer: _vm.GLOBAL_STYLES_DRAWER,
			tab: $event
		})}}}),_c('Transition',{attrs:{"name":"slide-right"}},[_c(_vm.currentTab.id,{tag:"Component",on:{"change-page":function($event){return _vm.$emit('change-page', $event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }